/* eslint-disable */
// import { defaultSession } from '@/store/modules/call-center'
import defaultHeadImg from '@/assets/images/lenovo-service2.png'
import userDefaultHeadImg from '@/assets/images/defaultHeadImg.png'
import cloudDefaultImage from '@/assets/images/cloudDefaultImage.png'
import { getDateFormat, uuid } from '@/utils'

/**
 * 将api提供的原始数据，转化为本项目自定义的Session结构
 * @param item
 * @param userType
 * @return {{}}
 */
// export const convertToSession = function(item, userType = 'wechat') {
//   item = { ...defaultSession, ...item }
//   item.userType = item.client_type ? item.client_type : 'wechat'

//   item.userType = userType
//   item.messages = []

//   // 如果engineer_name 为空，应该是机器人系统
//   if (!item.engineer_name) {
//     item.engineer_name = '系统'
//     item.engineer_code = 'robot'
//   }

//   return item
// }

/**
 * 将接收到的TX消息转化为客户端规则下的结构体
 * @param txMessage
 * @param session
 * @param engineerInfo
 * @returns {{}}
 */
const _ClientType = {
  engineer: 'engineer',
  user: 'user',
  robot: 'robot'
}
export const convertToMessage = function(
  txMessage,
  userInfo,
  engineerInfo,
  sessionId
) {
  if (!txMessage) return
  const re = {}
  // Error Message from server for push image into Message.vue before send it to server
  re.id = uuid('m')
  re.sessionId = sessionId || txMessage.MessageBody.SessionID
  re.type = txMessage.MessageBody.Body.Type || 'Text'
  // re.isEngineer = (txMessage.send_type + '') !== '100'
  // true 用户
  re.isEngineer =
    _ClientType[txMessage.MessageBody.ClientType] !== _ClientType['user']
  // 如果消息来自于机器人对话 send type = 300 or 400
  // 300=机器人回复，400=用户给机器人
  if (_ClientType[txMessage.MessageBody.ClientType] === _ClientType['robot']) {
    re.avatar = txMessage.MessageBody.avgineer_avatar || txMessage.MessageBody.engineer_avatar || cloudDefaultImage
    re.authorName = txMessage.MessageBody.engineer_name || '系统'
  } else {
    re.avatar =
      txMessage.MessageBody.avgineer_avatar || txMessage.MessageBody.engineer_avatar ||
      (engineerInfo && engineerInfo.engineer_img) ||
      cloudDefaultImage
      const engineer_name =
      txMessage.MessageBody.engineer_name === '无' ||
      !txMessage.MessageBody.engineer_name
      ? engineerInfo
      ? engineerInfo.name || engineerInfo.engineer_name
      : '系统'
      : txMessage.MessageBody.engineer_name
      re.authorName = re.isEngineer ? engineer_name : userInfo.user_name
      re.engineer_code = re.isEngineer
      ? engineerInfo
      ? engineerInfo.engineer_code || engineerInfo.engineer_code
      : ''
      : ''
    }
  re.client_type = txMessage.MessageBody.ClientType
  re.sendTime = txMessage.MessageBody.SendTime
  // re.showTime = setTime(txMessage.MessageBody.SendTime)
  re.timestamp = txMessage.MessageBody.SendTime
    ? Date.parse(txMessage.MessageBody.SendTime)
    : Date.parse(new Date(moment().format('YYYY-MM-DD HH:mm:ss')))
  if (re.type === 'Text') {
    re.content = txMessage.MessageBody.Body.Content.Text
  } else if (re.type === 'Image') {
    re.PicUrl = txMessage.MessageBody.Body.Content.Text
  } else if (re.type === 'Video') {
    re.MediaUrl = txMessage.MessageBody.Body.Content.Text
  } else if (re.type === 'File') {
    const content = txMessage.MessageBody.Body.Content
    re.content = {
      name: content.FileName,
      size: content.FileSize,
      url: content.MediaUrl,
      media: content.FileType,
      gid: content.gid
    }
  }
  re.emotion = txMessage.MessageBody.Body.Content.Emotion
  re.msgId = txMessage.MessageBody.msgId
  re.robotIndex = '-1'

  // 语音带翻译
  if (txMessage.message_type === 'Voice') {
    re.text = txMessage.text
    // todo 在语音消息里，历史消息和实时消息格式不一致，看RD能否处理
    if (/"text"/.test(re.text)) {
      re.text = JSON.parse(re.text).text
    }
  }
  return re
}

/**
 * 构建一个用户腾讯IM下的message结构
 * @param content
 * @param type
 * @param userInfo
 * @param sessionId
 */
export const convertToTXMessage = function(content, type, userInfo, sessionId) {
  // 将session 里对应的属性copy 到TxMessage 里
  const re = {
    MessageType: 'CC.ChatMessage',
    MessageBody: {
      SessionID: sessionId || sessionStorage.getItem('sessionId'),
      ChatRoute: 'webChat',
      ClientType: 'user',
      engineer_name: userInfo.user_name,
      id: uuid('m'),
      SendTime: getDateFormat(),
      // 'showTime': setTime(moment().format('YYYY-MM-DD HH:mm:ss')),
      avgineer_avatar: userInfo.avatar,
      Body: {
        Type: type,
        Content: {
          Text: content,
          Emotion: 0
        }
      }
    }
  }
  if (type === 'File') {
    re.MessageBody.Body.Content = {
      MediaUrl: content.url,
      FileName: content.name,
      FileSize: content.size,
      FileType: content.media,
      gid: content.gid
    }
  }

  return re
}

const arrEntities = {
  '&lt;': '<',
  '&gt;': '>',
  '&amp;': '&',
  '&quot;': '"',
  '&nbsp;': ' '
}

/**
 * 用于将安全的HTML 字符串 转译为标准HTML 字符串
 * @param content
 * @return {*}
 */
export const convertCharacterEntity = function(content) {
  return content.replace(/&lt;|&gt;|&amp;|&quot;|&nbsp;/g, function(match) {
    return arrEntities[match]
  })
}

/**
 * cube 自定义的TXIM 消息格式的处理
 * @param text
 * @return {{}}
 * @constructor
 */
export const IMMessageToJSON = function(text) {
  let re = {}
  try {
    const temp = convertCharacterEntity(text)
    // re = JSON.parse(temp.substring(1, temp.length - 1))
    const txt = temp.replace(/^"+/, '').replace(/"+$/, '')
    re = JSON.parse(txt)
  } catch (e) {
    console.log('[IMMessageToJSON Error]', text, e)
  }
  return re
}

/**
 * 中划线消息生成
 * @param text
 * @returns {{id: string, text: *, type: string}}
 */
export const convertSplitMessage = function(text) {
  return {
    id: uuid('split'),
    text,
    type: 'split'
  }
}

/**
 * 构建一条工程师发送的,先于HTTP请求,进入消息窗口临时消息
 * @param content 消息内容
 * @param type
 * @param userInfo
 * @return {{}}
 */
export const convertToEngineerTmpMessage = function(
  content,
  type,
  userInfo,
  engineerInfo,
  sessionId
) {
  const txTmpMsg = convertToTXMessage(content, type, userInfo, sessionId)
  const re = convertToMessage(txTmpMsg, userInfo, engineerInfo, sessionId)

  re.error = 'presending'
  return re
}

/**
 * 替换机器人聊天内容里的button
 * @param msg
 * @return {void | string|*}
 */
export const replaceButton = msg => {
  let answer = msg.content
  const btnReg = /<button>.*<\/button>/
  const btnItem = /<button>.*?<\/button>?/
  // const btnText = />.*</
  let btnGroup = ''
  let btnHasHelp = ''
  let btnNoHelp = ''
  if (msg.content.match(btnReg)) {
    btnGroup = answer.match(btnReg)[0]
    btnHasHelp = btnGroup
      .match(btnItem)[0]
      .replace('<button>', '')
      .replace('<img', '<img id="eva-btn1" msgId="' + msg.msgId + '"')
      .replace('</button>', '')
    btnNoHelp = btnGroup
      .replace(btnGroup.match(btnItem)[0], '')
      .match(btnItem)[0]
      .replace('<button>', '')
      .replace('<img', '<img id="eva-btn2" msgId="' + msg.msgId + '"')
      .replace('</button>', '')
    answer = answer.replace(btnGroup, `${btnHasHelp} ${btnNoHelp}`)
    return answer
  }
  return msg.content
}



// WEBPACK FOOTER //
// ./src/store/modules/call-center/convert.js